import { Box } from '@wix/design-system';
import { ProductsGrid } from '@wix/package-picker-components';
import classNames from 'classnames';
import { RootStore, withInjectedRootStore } from 'providers';
import React from 'react';
import { AdvancedPlansProductData } from 'types';
import { useSunriseProductCards } from '../hooks/useSunriseProductCards';
import s from './GridHeader.scss';

interface GridHeaderProps {
  products: AdvancedPlansProductData[];
  innerRef?: React.RefObject<HTMLDivElement>;
  rootStore: RootStore;
  onClickSelect: (
    productData: AdvancedPlansProductData,
    clickSource?: string,
  ) => void;
}

const GridHeaderComp: React.FC<GridHeaderProps> = ({
  products,
  rootStore,
  onClickSelect,
  innerRef,
}) => {
  const productsCards = useSunriseProductCards({
    baseProducts: products,
    appStore: rootStore.appStore,
    clickSource: 'table',
    onSelectProduct: onClickSelect,
    minimizedDisplay: true,
  });
  const { pricesIncludeTax, isInSale, isAnonymous } = rootStore.appStore;

  return (
    <ProductsGrid.Header innerRef={innerRef}>
      {productsCards.map((p, idx) => {
        const { title, cta, hat, price } = p.components;
        const zIndex = productsCards.length - idx;

        return (
          <ProductsGrid.Header.Cell
            zIndex={zIndex}
            className={classNames(s.headerCell, {
              [s.sale]: isInSale,
              [s.tax]: pricesIncludeTax,
              [s.anonymous]: isAnonymous,
            })}
          >
            <Box margin='6px' height='24px'>
              {hat}
            </Box>
            <Box align='center'>{title}</Box>
            <Box verticalAlign='middle'>{price}</Box>
            <Box className={s.cta} width='80%'>
              {cta}
            </Box>
          </ProductsGrid.Header.Cell>
        );
      })}
    </ProductsGrid.Header>
  );
};

export const GridHeader = withInjectedRootStore(GridHeaderComp);
